import React, { ReactNode } from 'react'

//Styles
import styles from './Tree.module.scss'

interface Props {
  children: ReactNode[]
}

const Tree = ({ children = [] }: Props) => {
  return (
    <ul className={styles.treeview} role="tree">
      { children }
    </ul>    
  )
}

export default Tree